const locale = {
  JOB_TITLE_TEXT_ADDITIONAL: 'Para impulsar tu carrera como <b>{{jobTitle}}</b>',
};

export default locale;
